var codeblock_default = {
  "blockStyleSpacing": "t9Tv8",
  "codeBlock": "eh4S4 t9Tv8",
  "renderedInTable": "qUkIg"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
